import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { PillarArticle, articleJsonLdForPillar } from "@/components/site/PillarArticle";
import { ShopifyPlusCostCalculator } from "@/components/site/ShopifyPlusCostCalculator";
import { buildHead, breadcrumbJsonLd, faqJsonLd } from "@/lib/seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";
import { SHOPIFY_PLUS_PRICING_COPY } from "@/lib/competitive-gap-resource-content";

const PATH = "/es/recursos/precios-shopify-plus";
const ALT = "/resources/shopify-plus-pricing";
const COPY = SHOPIFY_PLUS_PRICING_COPY.es;
const PUBLISHED = "2026-08-24T18:45:00.000Z";
const MODIFIED = "2026-11-04T17:00:00.000Z";
const TITLE = "Precio de Shopify Plus en 2026: $2,300–$2,500 USD/mes + costos y TCO";
const META_TITLE = "Precio Shopify Plus 2026: $2,300–$2,500 USD/mes | Shugert";
const DESCRIPTION =
  "Shopify Plus cuesta $2,500 USD/mes con contrato de 1 año o $2,300 USD/mes con contrato de 3 años, antes de pagos, apps, integraciones, migración e ingeniería.";
const INTRO =
  "Shopify documenta Plus en $2,500 USD al mes con contrato de un año o $2,300 USD al mes con contrato de tres años (Centro de ayuda de Shopify). Esa tarifa de plataforma es sólo la base: el número útil para decidir es el costo total de propiedad entre pagos, apps, integraciones, migración e ingeniería recurrente.";

export const Route = createFileRoute("/es/recursos/precios-shopify-plus")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "es",
    title: META_TITLE,
    description: DESCRIPTION,
    path: PATH,
    altPath: ALT,
    type: "article",
    author: "Samuel Noriega",
    articleAuthor: "Samuel Noriega",
    articleSection: "Economía Shopify Plus",
    publishedTime: PUBLISHED,
    modifiedTime: MODIFIED,
    jsonLd: [
      articleJsonLdForPillar({
        title: TITLE,
        description: DESCRIPTION,
        path: PATH,
        publishedTime: PUBLISHED,
        modifiedTime: MODIFIED,
        section: "Economía Shopify Plus",
      }),
      breadcrumbJsonLd([
        { name: "Inicio", path: "/es" },
        { name: "Recursos", path: "/es/recursos" },
        { name: "Precio Shopify Plus", path: PATH },
      ]),
      faqJsonLd(COPY.faqs),
    ],
  }),
  component: () => (
    <SiteShell>
      <PillarArticle
        locale="es"
        path={PATH}
        eyebrow={COPY.eyebrow}
        title={TITLE}
        intro={INTRO}
        updated="4 de noviembre de 2026"
        readingMinutes={COPY.readingMinutes}
        hubHref="/es/recursos"
        hubLabel="Ver todos los recursos"
        sections={COPY.sections}
        faqs={COPY.faqs}
        related={COPY.related}
        midCTA={COPY.midCTA}
        finalCTA={COPY.finalCTA}
        publishedTime={PUBLISHED}
        modifiedTime={MODIFIED}
        guideLabelEs="Guía de decisión"
        afterIntro={<ShopifyPlusCostCalculator locale="es" />}
      />
    </SiteShell>
  ),
});
